// Basic System
export const ACCOUNT = "ACCOUNT";
export const DASHBOARD = "DASHBOARD";
export const ACTIVITY = "ACTIVITY";

// Booking System
export const BOOKINGS = "BOOKINGS";
export const MANAGEMENT = "MANAGEMENT";
export const EMPLOYEES = "EMPLOYEES";
export const RESOURCES = "RESOURCES";
export const SERVICES = "SERVICES";
export const ROSTER = "ROSTER";

// Accounting System
export const ACCOUNTING = "ACCOUNTING";
export const INVOICES = "INVOICES";
export const RECURRING_INVOICES = "RECURRING_INVOICES";
export const CREDIT_NOTES = "CREDIT_NOTES";
export const CUSTOMER_STATEMENTS = "CUSTOMER_STATEMENTS";
export const PAYMENT_REMINDERS = "PAYMENT_REMINDERS";
export const CUSTOMERS = "CUSTOMERS";
export const ONLINE_PAYMENTS = "ONLINE_PAYMENTS";
